export const ResponseType = Object.freeze({
  TABLE: 'table',
  KANBAN: 'kanban',
  GROUP_BY_STATUS: 'group_by_status',
});
